import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { TooltipModule } from 'shared/components/tooltip/tooltip.module';
import { WorkItemLensListComponent } from './work-item-lens-list.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    SvgIconModule,
    TooltipModule
  ],
  declarations: [
    WorkItemLensListComponent
  ],
  exports: [
    WorkItemLensListComponent
  ]
})
export class WorkItemLensListModule {}
